import { render, staticRenderFns } from "./Form13StyleOfProceeding.vue?vue&type=template&id=221c23b3&scoped=true"
import script from "./Form13StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form13StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form13StyleOfProceeding.vue?vue&type=style&index=0&id=221c23b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c23b3",
  null
  
)

export default component.exports